import { useTableColumns } from '../../../../hooks/table/useTableColumns/useTableColumns';
import { useTableColumnWithFiltersAndSorters } from '../../../../hooks/useTableColumnWithFiltersAndSorters/useTableColumnWithFiltersAndSorters';
import { createPatientColumns } from '../../../patient/component/PatientsTableComponent/columns';
import { PatientsTableComponent } from '../../../patient/component/PatientsTableComponent/PatientsTableComponent';
import { PatientTableProps } from '../../../patients/type';

export interface ProviderViewUnenrolledPatientsTableComponentProps extends PatientTableProps {
}

export const ProviderViewUnenrolledPatientsTableComponent = ({
  totalSize,
  filters,
  sorters,
  ...props
}: ProviderViewUnenrolledPatientsTableComponentProps) => {
  const columns = useTableColumns(
    createPatientColumns,
    ['name', 'age', 'gender', 'clinic', 'mrn', 'registrationDate', 'dischargedDate'],
  );

  const columnsWithFilters = useTableColumnWithFiltersAndSorters({
    columns,
    filters,
    sorters: sorters || { columnKey: 'registrationDate', order: 'descend' },
  });

  return (
    <PatientsTableComponent
      totalSize={totalSize}
      columns={columnsWithFilters}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
    />
  );
};
